module.exports = __webpack_public_path__ + "h5/img/hide_prizes.44425bfe.png";